<template>
  <div class="width-100" :class="customClass">
    <label>
      <strong>{{ label }}</strong>
      <button v-if="canEdit" @click="toggleEdit">{{ editButtonText }}</button>
    </label>
    <editor-content v-if="isEditing" v-bind="editorProps" class="editor"></editor-content>
    <div v-else v-html="content" :class="viewModeClass"></div>
    <slot></slot>

  </div>
</template>

<script>
import {EditorContent} from "@tiptap/vue-3";

export default {
  name: "ContentPageField",
  components: {EditorContent},
  props: {
    label: { type: String, required: true },
    isEditing: { type: Boolean, required: true },
    content: { type: String, default: "" },
    editorProps: { type: Object, default: () => ({}) },
    canEdit: { type: Boolean, default: true },
    customClass: { type: String, default: "" },
    viewModeClass: { type: String, default: "view-mode" },
    editButtonText: { type: String, default: "✏️" },
  },
  emits: ["update:isEditing"],
  methods: {
    toggleEdit() {
      this.$emit("update:isEditing", !this.isEditing);
    },
  },
};
</script>


